/**
 * @file message-box 封装
 */
import {ElMessageBox as MessageBox} from '@/lib/element-polyfill';
import ZTMessageContanter from './message.vue';
import './index.scss';

const boxConfig = {
    modal: false, // 不需要遮罩
    closeOnClickModal: false,
    customClass: 'zt-message-box'
};


/***
 * 警告确认框
 * @param {string | VNode} message 显示字符
 * @param {Object} options 参数
 * @return {Object} thenable对象
 */
export function ztConfirm(message, options) {
    return MessageBox.confirm(
        <ZTMessageContanter message={message}/>,
        '',
        Object.assign({}, boxConfig, options)
    );
}


/***
 * 警告框
 * @param {string | VNode} message 显示字符
 * @param {Object} options 参数
 * @return {Object} thenable对象
 */
export function ztAlert(message, options) {
    return MessageBox.alert(
        <ZTMessageContanter message={message}/>,
        '',
        Object.assign({}, boxConfig, {modal: true}, options)
    );
}
